import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      quote: 'Changed our entire analytics workflow. We predict churn now instead of reacting to it. Saved $48K ARR in Q1 alone.',
      author: 'Sarah Chen',
      role: 'VP Operations, TechFlow'
    },
    {
      quote: 'Replaced 3 hours of weekly reporting with 30 seconds of asking Layrs. Plus we now understand WHY numbers move.',
      author: 'Marcus Rodriguez',
      role: 'CFO, GrowthLabs'
    },
    {
      quote: 'The audit trail feature is a game-changer. We can prove every decision to our board. Complete transparency.',
      author: 'Emily Thompson',
      role: 'Head of Finance, StartupCo'
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="container">
        <div className="testimonials">
          <div className="testimonials-header">
            <h3>What Customers Say</h3>
          </div>

          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial">
                <div className="testimonial-quote">"{testimonial.quote}"</div>
                <div className="testimonial-author">{testimonial.author}</div>
                <div className="testimonial-role">{testimonial.role}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
